<template>
  <div class="watermark-dev">DESENVOLVIMENTO</div>
</template>

<script>
export default {
  name: 'WatermarkDev',
}
</script>

<style scoped>
.watermark-dev {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  color: #ff5252;
  font-size: 30px;
  font-weight: bold;
  opacity: 0.25;
  pointer-events: none;
  user-select: none;
  letter-spacing: 2px;
}
</style>
